import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

/**
 * Something the CRM recorded in the thread, that nobody sent.
 *
 * ★ IT IS A REAL STORED MESSAGE, DRAWN AS A DIVIDER.
 * The row exists in `meta_wa_messages` because the thread is paginated and the
 * reader holds only a window of it — a note the browser injected would have no
 * correct position in a partial list. But it was never sent to anyone, so it
 * must not look like it was: without this branch it renders as a green outbound
 * bubble with a delivery tick, because `status` defaults to ACCEPTED.
 *
 * Same shape as `UnreadDivider` and the day pill, because it is the same kind
 * of thing — a line across the conversation rather than a thing someone said.
 */
export default function SystemNote({ text }) {
	if (!text) return null;

	return (
		<Flex justify="center" my="3" px="4" role="note">
			<Text
				fontSize="0.7rem"
				color="wa.inkMuted"
				bg="wa.datePill"
				px="3"
				py="1.5"
				borderRadius="md"
				boxShadow="0 1px 0.5px rgba(0,0,0,0.13)"
				textAlign="center"
				maxW="420px"
				lineHeight="1.5"
			>
				{text}
			</Text>
		</Flex>
	);
}
